import dayjs from 'dayjs'

import type { TT } from '@/src/lang/useTranslate'

import type { TDateArg } from '../primitives/dates/date.types'
import { formatCalendar, getDiffInDays } from '../primitives/dates/dayjs'
import { capitalizeFirstLetter } from '../primitives/strings/capitalize'

export type TSection<Item> = {
  /** Nb days since item date (no now) */
  title: number
  data: Item[]
  totalItems: number
}

export const sectionizeInfiniteData = <Item>(data: Item[], getItemDate: (item: Item) => TDateArg) => {
  const sections: Record<number, typeof data> = {}

  const mapSectionIndex: Record<string, number> = {}
  // We use a for loop instead of forEach for slight performance improvement
  for (let i = 0; i < data.length; i++) {
    const item = data[i]
    const sectionTitle = getDiffInDays(getItemDate(item), Date.now())

    if (!sections[sectionTitle]) {
      sections[sectionTitle] = []
    }
    sections[sectionTitle].push(item)
  }
  const transformedSections: TSection<Item>[] = []
  for (const [i, [title, items]] of Object.entries(sections).entries()) {
    mapSectionIndex[title] = i

    transformedSections.push({ title, data: items, totalItems: data.length })
  }

  return { transformedSections, mapSectionIndex }
}

export const getFormattedSectionTitle = (section: TSection<unknown>, t: TT) =>
  capitalizeFirstLetter(formatCalendar(dayjs().subtract(section.title, 'days'), t))
